export class FornecedorEstrutura {
  id: number;
  nome: string;
  logo: string;
  ativo: boolean;
  logo$: Promise<any>;
  buscouImagem: boolean;
}
